import RecurringForm from 'components/form/RecurringForm/styled';

export default RecurringForm;
